import React, {useState} from "react";
import {Button} from "@mui/material";
import moment from "moment/moment";
import StaffNZCARShowPayload from "./StaffNZCARShowPayload";

export default function StaffNZCARShowAction({view,enabled,postData,postDataManually,buttonEnabled,row}){


    const [openPayload,setOpenPayload] = useState(false);
    if(view === 'new') return (
        <>
            <Button variant={"contained"} size={"small"} disabled={!enabled}
                    onClick={() => postData()}>
                Send to NZCAR API
            </Button>
        </>
    )

    if(view === 'success') return (
        <>
            {(buttonEnabled === true) ? "Record created " + moment(row.created_at).format("DD/MM/YYYY HH:mm") : "API disabled for now"}
        </>
    )

    return (
        <div style={{color:'red'}}>
            Add animal manually.&nbsp;<br />
            <a href={""} className={"btn"} style={{color:'red'}} onClick={(e) => {
                e.preventDefault();
                setOpenPayload(true)
            }}>
                Click here to see the data for this animal.
            </a><br />
            <Button variant={"contained"} size={"small"} onClick={() => postDataManually()}>
                Mark as done
            </Button>
            {
                (openPayload === true) ?
                    <StaffNZCARShowPayload {...{view, enabled, postData, postDataManually, buttonEnabled, row}} key={Date.now()} isOpen={openPayload} setIsOpen={setOpenPayload} message={JSON.parse(row.payload)}/>
                    : undefined
            }
        </div>
    )
}
